module.exports = __webpack_public_path__ + "img/1.58ec8744.svg";